import i18next from 'i18next';
import { trackPromise } from 'react-promise-tracker';
import api from '../api/api';
import { MocksHelper } from './mocks/MocksHelper';
import TravelMockService from './mocks/TravelMockService';

// eslint-disable-next-line react-hooks/rules-of-hooks
const mocked = MocksHelper.useMocks();

const TravelService = {
  retrieveTravels: () =>
    trackPromise(api.post(`/rest/puntos/travel/${i18next.language}/get/info`)),
  retrieveTravelsWithDate: (data: object) =>
    trackPromise(
      api.post(
        `/rest/puntos/travel/${i18next.language}/get/info/dates`,
        JSON.stringify(data),
      ),
    ),
};
export default mocked ? TravelMockService : TravelService;
